var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDurabilidadColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6C6C6C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45,58.6c-1.1,0-2.1-0.5-2.8-1.4l-12-14.9c-1.4-1.5-1.3-3.9,0.2-5.3c1.4-1.4,3.8-1.3,5.1,0.2 c0.1,0.1,0.2,0.2,0.2,0.3l12.1,14.9c1.3,1.6,1.1,3.9-0.5,5.3c0,0,0,0-0.1,0.1C46.7,58.4,45.9,58.7,45,58.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.5,51.1c-2,0-3.6-1.7-3.6-3.8V25c0.2-2,1.8-3.6,3.8-3.5c1.8,0.2,3.2,1.6,3.4,3.5v22.5 C75.1,49.5,73.5,51.1,71.5,51.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98,58.6c-2,0-3.6-1.7-3.6-3.8c0-0.8,0.2-1.5,0.7-2.2l12.1-17.5c1.1-1.7,3.4-2,5.1-0.8s2,3.5,0.8,5.2L100.9,57 C100.3,58.1,99.1,58.6,98,58.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.8,83.6c-2,0.1-3.6-1.6-3.7-3.6c-0.1-1.7,1-3.1,2.4-3.6l19.2-7.5c1.9-0.7,3.9,0.5,4.6,2.4 c0.6,1.9-0.3,3.8-2,4.6l-19.2,7.5C115.7,83.5,115.3,83.6,114.8,83.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131.7,118.5c-0.5,0-1-0.1-1.4-0.3l-16.9-7.5c-1.8-1-2.5-3.2-1.6-5.1c0.8-1.7,2.7-2.4,4.4-1.8l16.9,7.5 c1.8,0.8,2.7,3,1.9,4.9C134.4,117.6,133.2,118.5,131.7,118.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.5,131c-20.6,0-37.3-17.3-37.3-38.7c0-21.3,16.7-38.7,37.3-38.7s37.3,17.3,37.3,38.7l0,0 C108.8,113.7,92.1,131,71.5,131z M71.5,61.1c-16.6,0-30.1,14-30.1,31.2s13.4,31.2,30.1,31.2s30.1-14,30.1-31.2l0,0 C101.6,75.1,88.1,61.2,71.5,61.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.9,149.7c-1.1,0-2.1-0.5-2.8-1.4L94,133.5c-1.4-1.5-1.3-3.9,0.2-5.3c1.4-1.4,3.8-1.3,5.1,0.2 c0.1,0.1,0.2,0.2,0.2,0.3l12.1,14.9c1.3,1.6,1.1,3.9-0.5,5.3C110.5,149.5,109.7,149.8,108.9,149.7L108.9,149.7L108.9,149.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.3,164.7c-2,0-3.6-1.7-3.6-3.7l0,0v-22.5c0-2,1.6-3.8,3.6-3.8c2,0,3.6,1.7,3.6,3.8l0,0v22.4 C73.9,163,72.3,164.7,70.3,164.7L70.3,164.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.8,152.2c-0.8,0-1.5-0.2-2.1-0.7c-1.6-1.2-2-3.5-0.8-5.2l0,0l12.1-17.5c1.1-1.7,3.4-2,5.1-0.8 s2,3.5,0.8,5.2l0,0l-12.1,17.5C34,151.6,33,152.2,31.8,152.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.7,117.3c-2,0.1-3.6-1.6-3.7-3.6c-0.1-1.7,1-3.1,2.4-3.6l19.2-7.5c1.9-0.7,3.9,0.5,4.6,2.4 c0.6,1.9-0.3,3.8-2,4.6L9,117.1C8.6,117.2,8.1,117.2,7.7,117.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.9,82.4c-0.5,0-1-0.1-1.4-0.3L8.6,74.6c-1.8-1-2.5-3.2-1.6-5.1c0.8-1.7,2.7-2.4,4.4-1.8l16.9,7.5 c1.8,0.8,2.7,3,1.9,4.9C29.7,81.5,28.4,82.3,26.9,82.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.7,176h-18l-0.4-2.2C139.6,73.9,157.3,6.6,157.4,6l0.5-2H176l-0.9,3.4c-0.2,0.7-17.5,66.8,0,165.5 L175.7,176z M162,170.7h7.6c-14.7-85.8-3.5-146.8-0.2-161.4h-7.5C159.2,20.8,146.7,82.6,162,170.7L162,170.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDurabilidadColor);
export default __webpack_public_path__ + "static/media/durabilidad-color.f6f9107a4ee7618be125cfab85f332f8.svg";
export { ForwardRef as ReactComponent };